var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 630,
    height: 381,
    viewBox: "0 0 630 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "homepage",
    transform: "translate(7320 -2127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 630,
    height: 381,
    rx: 26,
    transform: "translate(-7320 2127)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7009",
    "data-name": "Group 7009",
    transform: "translate(-8312 -24592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7007",
    "data-name": "Group 7007"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    width: 141,
    height: 174,
    rx: 35,
    transform: "translate(1120 26810)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title",
    width: 139,
    height: 13,
    rx: 6.5,
    transform: "translate(1121 26997)",
    fill: "#77777a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7008",
    "data-name": "Group 7008",
    transform: "translate(234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566-2",
    "data-name": "Rectangle 1566",
    width: 141,
    height: 174,
    rx: 35,
    transform: "translate(1120 26810)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-2",
    "data-name": "Title",
    width: 139,
    height: 13,
    rx: 6.5,
    transform: "translate(1121 26997)",
    fill: "#77777a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7006",
    "data-name": "Group 7006",
    transform: "translate(-8327 -24592)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_3",
    "data-name": 3,
    width: 24,
    height: 11,
    rx: 5.5,
    transform: "translate(1565 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2",
    "data-name": 2,
    width: 24,
    height: 11,
    rx: 5.5,
    transform: "translate(1530 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_1",
    "data-name": 1,
    width: 23,
    height: 11,
    rx: 5.5,
    transform: "translate(1495 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    width: 56,
    height: 18,
    rx: 9,
    transform: "translate(1055 26746)",
    fill: "#858585"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.2ecfd376bd8372151f0a1ddc996767fb.svg";
export { ForwardRef as ReactComponent };